export class SessionExpiredError extends Error {
    constructor(message = 'Session expired') { super(message); this.name = 'SessionExpiredError'; }
}

// Deployed QA/prod run as a single bundle — SalesApi serves the SPA and the API
// from the same origin — so use relative URLs. This works on the App Service host
// (ktmsales-qa.azurewebsites.net) and on any custom domain mapped to it, with no
// rebuild. Local dev runs the SPA (:3000) and API on different ports, so it needs
// the absolute local URL. REACT_APP_DEPLOY_ENV is set at build time by deploy.js.
export const getApiUrl = () => {
    if (process.env.REACT_APP_DEPLOY_ENV === 'production') return '';
    if (process.env.REACT_APP_DEPLOY_ENV === 'qa') return '';
    return process.env.REACT_APP_API_URL_LOCAL;
};

export const authFetch = async (url, options = {}, { currentUser, onSessionExpired, onTokenRefresh }) => {
    if (!currentUser?.token) { onSessionExpired?.(); throw new SessionExpiredError('No authentication token'); }
    const response = await fetch(url, { ...options, headers: { ...options.headers, Authorization: `Bearer ${currentUser.token}` } });
    if (response.status === 401) { onSessionExpired?.(); throw new SessionExpiredError(); }
    const newToken = response.headers.get('X-New-Token');
    if (newToken && onTokenRefresh) onTokenRefresh(newToken);
    return response;
};

export const authPost = (url, body, authParams) =>
    authFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }, authParams);

export const authGet = (url, authParams) => authFetch(url, { method: 'GET' }, authParams);
